import { render, staticRenderFns } from "./Firestore.vue?vue&type=template&id=685c60fa&"
import script from "./Firestore.vue?vue&type=script&lang=js&"
export * from "./Firestore.vue?vue&type=script&lang=js&"
import style0 from "./Firestore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports